import * as React from 'react'
import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { useConvexAuth } from 'convex/react'
import { LoginScreen } from '@/components/login-screen'
import Spinner from '@/components/spinner'
import { NotFound } from '@/components/not-found'

import '../styles/app.css'

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
})

function RootComponent() {
  const { isLoading, isAuthenticated } = useConvexAuth()
  const everAuthenticated = React.useRef(false)

  if (isAuthenticated) {
    everAuthenticated.current = true
  }

  if (isLoading && !everAuthenticated.current) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-10" />
      </div>
    )
  }

  if (!isAuthenticated && !isLoading) {
    return <LoginScreen />
  }

  return (
    <>
      <Outlet />
      <TanStackDevtools
        config={{
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'TanStack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
        ]}
      />
    </>
  )
}
